import axios from "axios";


const MP_API_HIPERGAS = "https://mphipergas.netizar.com";
const MP_API_NATURAL = "https://mpnatural.netizar.com";

// const MP_API_HIPERGAS = "https://b0cb-190-2-10-4.ngrok-free.app";
// const MP_API_NATURAL = "https://b0cb-190-2-10-4.ngrok-free.app";

const baseUrlEmpresa = (idEmpresa) =>
  Number(idEmpresa) === 1 ? MP_API_HIPERGAS : MP_API_NATURAL;

// Mensaje de error legible de una respuesta de la API de MP
export const mensajeError = (err, porDefecto) =>
  err?.response?.data?.message || err?.message || porDefecto;

// Crea la order en MP para el registro elcId. El monto y la referencia los toma la API del registro.
export const crearLinkEnvasadoCc = async (idEmpresa, elcId, cuotas) => {
  const resp = await axios.post(`${baseUrlEmpresa(idEmpresa)}/api/link-envasado-cc/create`, {
    elcId,
    ...(cuotas ? { cuotas } : {}),
  });
  if (!resp.data?.ok || !resp.data?.data) {
    throw new Error(resp.data?.message || "Error generando el link en Mercado Pago");
  }
  return resp.data.data;
};

// Consulta la order en MP y actualiza el estado del registro (pagado / expirado)
export const verificarLinkEnvasadoCc = async (idEmpresa, elcId) => {
  const resp = await axios.post(
    `${baseUrlEmpresa(idEmpresa)}/api/link-envasado-cc/verificar/${elcId}`
  );
  return resp.data?.data;
};

// Cancela la order en MP (si todavía se puede pagar) y anula el registro
export const anularLinkEnvasadoCc = async (idEmpresa, elcId) => {
  const resp = await axios.post(
    `${baseUrlEmpresa(idEmpresa)}/api/link-envasado-cc/anular/${elcId}`
  );
  return resp.data?.data;
};
